import React from 'react'
import { displayShortName } from '../helpers/globals'

function Avatar({ userName = '', userImage = '', className='', imgClass='' }) {
    return (
        <div className={`assign-user ${className}`}>
            {userImage ?
                <img className={imgClass} alt="" src={userImage} />
                :
                <span>{displayShortName(userName)}</span>
            }
        </div>
    )
}

export default Avatar